import React from 'react';
import {BottomNavigation, BottomNavigationAction} from '@mui/material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import BarChartIcon from '@mui/icons-material/BarChart';
import JournalIcon from '@mui/icons-material/MenuBook';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ContrastSharp from '@mui/icons-material/ContrastSharp';
import {useNavigate} from "react-router-dom";

const BottomNav = ({darkMode, toggleDarkMode}) => {
    const navigate = useNavigate();

    const handleClick = (to) => {
        navigate(to);
    };

    return (
        <BottomNavigation showLabels style={{position: 'fixed', bottom: 0, width: '100%'}}>
            <BottomNavigationAction label="Отчет" icon={<BarChartIcon/>} onClick={() => handleClick('/spa/report')}/>
            <BottomNavigationAction label="Записи" icon={<JournalIcon/>} onClick={() => handleClick('/spa/journal')}/>
            <BottomNavigationAction label="Новая" icon={<AddBoxIcon/>} onClick={() => handleClick('/spa/transaction')}/>
            <BottomNavigationAction label="Счета" icon={<AccountBalanceIcon/>}/>
            <BottomNavigationAction label={darkMode ? "Темная" : "Светлая"} icon={<ContrastSharp/>} onClick={toggleDarkMode} />
        </BottomNavigation>
    );
};

export default BottomNav;
